module.exports = __webpack_public_path__ + "img/footer-m.553a9d23.svg";